<template>
  <div>
    <CCard>
      <CCardHeader> <CIcon name="cil-grid" />Users </CCardHeader>
      <CCardBody>
        <div style="overflow: auto">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>No</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>LastLogin</th>
                <th>FCM Token</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, k) in items" :key="k">
                <td>
                  <table-number
                    :index="k"
                    :page="paginator.page"
                    :size="paginator.size"
                  />
                </td>
                <td>{{ v.name }}</td>
                <td>{{ v.phone }}</td>
                <td>{{ v.email }}</td>
                <td>{{ v.last_login }}</td>
                <td>
                  <span
                    @click="copyToken(v.fcm_token)"
                    class="pointer"
                    v-c-tooltip.hover.click="'Click to Copy'"
                    >{{ v.fcm_token | fcmFilter }}</span
                  >
                </td>
                <td>{{ v.created_at }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCardBody>
      <CCardFooter>
        <content-pagination :paginator="paginator" @change="changePage" />
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber";
import ContentPagination from "../../components/ContentPagination2.vue";
export default {
  components: {
    TableNumber,
    ContentPagination,
  },
  data() {
    return {
      items: [],
      paginator: {},
    };
  },
  created() {
    this.getList(1, "");
  },
  methods: {
    getList(page, q) {
      HTTPAUTH.get(
        `/api/admin/user?page=${page}&size=${10}&sort=name:asc&q=${q}`
      ).then((res) => {
        this.items = res.data.data;
        this.paginator = res.data.paginate;
      });
    },
    changePage(p) {
      this.getList(p, "");
    },
    copyToken(data) {
      navigator.clipboard.writeText(data).then(() => {
        this.$toasted.success("Data sudah tercopy").goAway();
      });
    },
  },
  filters: {
    fcmFilter(t) {
      if (t) {
        return t.substring(0, 10) + "...";
      }
      return "";
    },
  },
};
</script>